import { __extends as r } from "tslib";
import { LiffModule as t } from "@liff/use";
import { getLineVersion as i } from "@liff/get-line-version";
import { getOS as n } from "@liff/get-os";
import { compareVersion as o } from "@liff/util";
import { isInClient as e } from "@liff/is-in-client";
function f() {
  var r = i();
  if (!r || !e() || "ios" !== n()) return navigator.language;
  if (o(r, "14.11.0") >= 0) {
    var t = window.prompt("LIFF:GET_APP_LANGUAGE");
    if (t) return t;
  }
  return navigator.language;
}
var u = function (t) {
  function i() {
    return null !== t && t.apply(this, arguments) || this;
  }
  return r(i, t), Object.defineProperty(i.prototype, "name", {
    get: function () {
      return "getAppLanguage";
    },
    enumerable: !1,
    configurable: !0
  }), i.prototype.install = function () {
    return function () {
      return f();
    };
  }, i;
}(t);
export { u as GetAppLanguageModule, f as getAppLanguage };